import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ButtonWithArrow } from "@/components/common/Button/ButtonWithArrow";
import { useCategoryFilterHandler } from "@/hooks/useCategoryFilterHandler";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { BRAND_HOME_PAGE, BRAND_PRODUCTS_PAGE, LAB_PRODUCTS_CATEGORY } from "@/settings/constant";
import { Box, Divider, Typography, styled, useTheme } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useCallback, useMemo } from "react";
import { getBrandCategory } from "src/api/brand";
import { StyleBox } from "src/pages/labs/[author]/products";
import { Accordions, AccordionsContainer } from "../../../common/Accordian";
import Icon from "../../../icon/Icon";
import { ArrowDown, Sizes } from "../../../icon/IconList";
import { useBrandStore } from "../../BrandProvider";
import { routerOptions } from "../Search/useSearchBarHandler";
export const DEFAULT_EMOJI = "\uD83C\uDFB2";
const CATEGORY_PATH = "/category";
const BrandCategory = (param)=>{
    let { isStyledRadius , onClose  } = param;
    const router = useRouter();
    const { asPath  } = useRouter();
    const theme = useTheme();
    const name = useBrandStore((state)=>state.brand.name);
    const { handleCategoryMenu  } = useCategoryFilterHandler({
        isUseAsPath: true,
        routerOptions: routerOptions
    });
    const { isMobile , isTablet  } = useWindowDimensions();
    const path = useMemo(()=>{
        // category 경로가 없을 경우, 붙여줍니다
        const current = asPath.split("?")[0];
        if (!current.includes("products")) return LAB_PRODUCTS_CATEGORY //상품 페이지가 아닌 페이지에서의 카테고리페이지 이동
        ;
        else if (!current.includes("category")) return CATEGORY_PATH //카테고리 페이지가 아닌 페이지에서의 카테고리페이지 이동
        ;
        return "" //category 페이지 내에서의 이동
        ;
    }, [
        asPath
    ]);
    const onCategoryMenuClick = useCallback((id)=>{
        handleCategoryMenu(id, path);
    }, [
        path,
        handleCategoryMenu
    ]);
    const { data: categoryData  } = useQuery([
        "brandCategory",
        name
    ], ()=>getBrandCategory(name), {
        enabled: !!name
    });
    if (!(categoryData === null || categoryData === void 0 ? void 0 : categoryData.depthItems.length)) return null;
    var _oneDepth_emoji, _oneDepth_emoji1, _item_emoji;
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            // 브랜드가 없을때는 해당 컴포넌트 노출 안함
            /*#__PURE__*/ _jsx(StyleBox, {
                sx: {
                    display: isStyledRadius ? "block" : "none"
                },
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "h5",
                    children: "브랜드 카테고리"
                })
            }),
            /*#__PURE__*/ _jsx(CategoryBox, {
                children: /*#__PURE__*/ _jsx(Box, {
                    children: /*#__PURE__*/ _jsx(AccordionsContainer, {
                        sx: {
                            width: "100%"
                        },
                        children: categoryData && categoryData.depthItems.map((oneDepth)=>{
                            var _oneDepth_items, _oneDepth_items1, _oneDepth_items2;
                            /*#__PURE__*/ return _jsxs(Accordions, {
                                id: String(oneDepth.categoryId),
                                sx: {
                                    padding: 0,
                                    boxShadow: "none",
                                    "&.MuiPaper-root": {
                                        margin: 0,
                                        width: "100% !important"
                                    },
                                    "&.MuiPaper-root.Mui-expanded": {
                                        width: "100% !important",
                                        overflow: "hidden",
                                        backgroundColor: theme.palette.grey[0],
                                        borderRadius: isStyledRadius ? "6px" : "none",
                                        [theme.breakpoints.down("lg")]: {
                                            borderRadius: "0"
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Accordions.Summary, {
                                        expandIcon: ((_oneDepth_items = oneDepth.items) === null || _oneDepth_items === void 0 ? void 0 : _oneDepth_items.length) && /*#__PURE__*/ _jsx(Icon, {
                                            icon: ArrowDown,
                                            color: theme.palette.grey[300],
                                            size: Sizes.small
                                        }),
                                        sx: (theme)=>({
                                                ...stylesSummary(theme),
                                                ".MuiAccordionSummary-content": {
                                                    width: "100%"
                                                }
                                            }),
                                        onClick: ()=>{
                                            //mx-195 카테고리 메뉴 클릭시
                                            mixpanelEvent("Brand Category Menu Clicked", {
                                                Depth: 1,
                                                "Menu Name": oneDepth.title,
                                                Url: null,
                                                "Brand Name": name,
                                                Position: isStyledRadius ? asPath === BRAND_HOME_PAGE(name) ? "홈 탭" : "상품 탭" : "사이드시트"
                                            });
                                        },
                                        children: ((_oneDepth_items1 = oneDepth.items) === null || _oneDepth_items1 === void 0 ? void 0 : _oneDepth_items1.length) ? /*#__PURE__*/ _jsxs("p", {
                                            style: {
                                                display: "flex",
                                                gap: "6px",
                                                color: theme.palette.text.primary
                                            },
                                            children: [
                                                "".concat((_oneDepth_emoji = oneDepth.emoji) !== null && _oneDepth_emoji !== void 0 ? _oneDepth_emoji : DEFAULT_EMOJI, " ").concat(oneDepth.title),
                                                /*#__PURE__*/ _jsx(Typography, {
                                                    variant: "body1",
                                                    component: "span",
                                                    sx: {
                                                        color: theme.palette.text.disabled
                                                    },
                                                    children: oneDepth.count
                                                })
                                            ]
                                        }) : /*#__PURE__*/ _jsxs(Typography, {
                                            component: "button",
                                            onClick: ()=>{
                                                onCategoryMenuClick(oneDepth.categoryId);
                                                //mx-195 카테고리 메뉴 클릭시
                                                mixpanelEvent("Brand Category Menu Clicked", {
                                                    Depth: 1,
                                                    "Menu Name": oneDepth.title,
                                                    Url: path,
                                                    "Brand Name": name,
                                                    Position: isStyledRadius ? asPath === BRAND_HOME_PAGE(name) ? "홈 탭" : "상품 탭" : "사이드시트"
                                                });
                                                if (onClose) onClose();
                                            },
                                            sx: {
                                                all: "unset",
                                                cursor: "pointer"
                                            },
                                            children: [
                                                "".concat((_oneDepth_emoji1 = oneDepth.emoji) !== null && _oneDepth_emoji1 !== void 0 ? _oneDepth_emoji1 : DEFAULT_EMOJI, " ").concat(oneDepth.title, " "),
                                                /*#__PURE__*/ _jsx(Typography, {
                                                    variant: "body1",
                                                    component: "span",
                                                    sx: {
                                                        color: theme.palette.text.disabled
                                                    },
                                                    children: oneDepth.count
                                                })
                                            ]
                                        })
                                    }),
                                    ((_oneDepth_items2 = oneDepth.items) === null || _oneDepth_items2 === void 0 ? void 0 : _oneDepth_items2.length) && /*#__PURE__*/ _jsx(Accordions.Details, {
                                        children: /*#__PURE__*/ _jsx("ul", {
                                            style: {},
                                            children: oneDepth.items.map((item, index)=>/*#__PURE__*/ _jsx(CategoryRow, {
                                                    component: "button",
                                                    onClick: ()=>{
                                                        onCategoryMenuClick(item.categoryId);
                                                        //mx-195 카테고리 메뉴 클릭시
                                                        mixpanelEvent("Brand Category Menu Clicked", {
                                                            Depth: 2,
                                                            "Menu Name": item.title,
                                                            Url: path,
                                                            "Brand Name": name,
                                                            Position: isStyledRadius ? asPath === BRAND_HOME_PAGE(name) ? "홈 탭" : "상품 탭" : "사이드시트"
                                                        });
                                                        if (onClose) onClose();
                                                    },
                                                    children: /*#__PURE__*/ _jsxs(Typography, {
                                                        sx: {
                                                            all: "unset",
                                                            cursor: "pointer",
                                                            width: "100%"
                                                        },
                                                        children: [
                                                            "".concat((_item_emoji = item.emoji) !== null && _item_emoji !== void 0 ? _item_emoji : DEFAULT_EMOJI, " ").concat(item.title, " "),
                                                            /*#__PURE__*/ _jsx(Typography, {
                                                                variant: "body1",
                                                                component: "span",
                                                                sx: {
                                                                    color: theme.palette.text.disabled
                                                                },
                                                                children: item.count
                                                            })
                                                        ]
                                                    })
                                                }, index))
                                        })
                                    })
                                ]
                            }, oneDepth.categoryId);
                        })
                    })
                })
            }),
            asPath === BRAND_HOME_PAGE(name) && (categoryData === null || categoryData === void 0 ? void 0 : categoryData.depthItems.length) > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        sx: {
                            display: "flex"
                        },
                        children: /*#__PURE__*/ _jsx(ButtonWithArrow, {
                            variant: isTablet ? "strokeSecondary" : "text",
                            iconColor: "#6A708A",
                            onClick: ()=>{
                                //mx-28 전체보기 버튼 클릭시
                                mixpanelEvent("More Button Clicked", {
                                    "Button Type": "브랜드 홈",
                                    "Button Name": "전체보기",
                                    "Button Url": BRAND_PRODUCTS_PAGE(name)
                                });
                                router.push(BRAND_PRODUCTS_PAGE(name));
                            },
                            sx: (theme)=>({
                                    width: "100%",
                                    color: "#6A708A",
                                    fontSize: "16px",
                                    margin: "12px 32px 0 32px",
                                    [theme.breakpoints.down("sm")]: {
                                        margin: "12px 20px 0 20px"
                                    }
                                }),
                            children: "전체보기"
                        }, "button")
                    }),
                    /*#__PURE__*/ _jsx(Divider, {
                        sx: (theme)=>({
                                marginTop: "40px",
                                [theme.breakpoints.down("lg")]: {
                                    marginTop: "32px"
                                },
                                [theme.breakpoints.down("sm")]: {
                                    marginTop: "28px"
                                }
                            })
                    })
                ]
            })
        ]
    });
};
const Container = styled("div")((param)=>{
    let { theme  } = param;
    return {};
});
const CategoryBox = styled("div")((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "12px",
        li: {
            "&:hover": {
                cursor: "pointer",
                backgroundColor: "rgba(169, 175, 199, 0.20)"
            }
        },
        [theme.breakpoints.down("lg")]: {
            borderRadius: "0"
        },
        [theme.breakpoints.down("sm")]: {
            borderRadius: "0"
        }
    };
});
const stylesSummary = (theme)=>({
        ...theme.typography.subtitle1,
        color: theme.palette.text.secondary,
        justifyContent: "space-between",
        gap: "8px",
        flexGrow: "inherit",
        padding: "12px 20px",
        "&.MuiAccordionSummary-root.Mui-expanded": {
            backgroundColor: "rgba(169, 175, 199, 0.20)",
            minHeight: "48px",
            margin: 0,
            // overflow: 'hidden',
            [theme.breakpoints.down("lg")]: {
                borderRadius: "0",
                padding: "0 32px"
            },
            [theme.breakpoints.down("sm")]: {
                borderRadius: "0",
                padding: "0 20px"
            }
        },
        ".Mui-focusVisible": {
            backgroundColor: "none"
        },
        "&.MuiAccordionSummary-root": {
            [theme.breakpoints.down("lg")]: {
                padding: "12px 32px"
            },
            [theme.breakpoints.down("sm")]: {
                padding: "12px 20px"
            }
        },
        "&.MuiAccordionSummary-root:hover": {
            backgroundColor: "rgba(169, 175, 199, 0.20)"
        }
    });
const CategoryRow = styled("li")((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        padding: "12px 40px",
        textAlign: "left",
        // margin: '0 20px',
        button: {
            padding: "0 20px"
        },
        [theme.breakpoints.down("lg")]: {
            padding: "12px 40px"
        },
        [theme.breakpoints.down("sm")]: {
            padding: "12px 20px"
        }
    };
});
export default BrandCategory;
